import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_GAMES,
  GET_MAINTENANCE_GAMES,
  MAINTENANCE_GAME,
  GAME_UPDATE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'game' })
export default class Game extends VuexModule {
  game: any = [];

  @Mutation
  mutateGame(game: any) {
    this.game = game;
  }

  @Action({ commit: 'mutateGame' })
  FetchGame() {
    return Vue.axios({
      url: BASE_URL + GET_GAMES,
      method: M_POST,
      data: {},
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const game = data.data;
          return game;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateGame' })
  FetchMaintenanceGame() {
    return Vue.axios({
      url: BASE_URL + GET_MAINTENANCE_GAMES,
      method: M_POST,
      data: {},
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const game = data.data;
          return game;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  MaintenanceGames(params) {
    return Vue.axios({
      url: BASE_URL + MAINTENANCE_GAME,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  GameVersion(params) {
    return Vue.axios({
      url: BASE_URL + GAME_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
